import TaskIndicatorCard from "../../components/taskIndicatorCard";

export const indicatorsExecutedvsProjectedCards = (data) => {
  return (
    <>
      <TaskIndicatorCard
        title="Total Actividades"
        value={
          data?.total_activities_created ? data?.total_activities_created : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="Total Actividades Planificadas"
        value={data?.total_projected_days ? data?.total_projected_days : "-"}
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="Cumplimiento (%)"
        value={
          data?.compliance_pct
            ? data?.total_executed_days + " (" + data?.compliance_pct + " %)"
            : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        text={data?.compliance_message}
        color={data?.compliance_color}
      />
    </>
  );
};

export const indicatorsPlannedNotExcecutedCards = (data) => {
  return (
    <>
      <TaskIndicatorCard
        title="Total Actividades Planificadas"
        value={data?.total_projected_days ? data?.total_projected_days : "-"}
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="% Actividades NO Ejecutadas"
        value={data?.compliance_pct ? data?.compliance_pct : "-"}
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        text={data?.compliance_message}
        color={data?.compliance_color}
      />
    </>
  );
};

export const indicatorsExecutedvsNoProjectedCards = (data) => {
  return (
    <>
      <TaskIndicatorCard
        title="Total Actividades"
        value={
          data?.total_activities_created ? data?.total_activities_created : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="Total Actividades No Planificadas"
        value={
          data?.total_non_projected_days ? data?.total_non_projected_days : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="Cumplimiento (%)"
        value={
          data?.compliance_pct
            ? data?.total_executed_days + " (" + data?.compliance_pct + " %)"
            : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        text={data?.compliance_message}
        color={data?.compliance_color}
      />
    </>
  );
};

export const unplannedExecutedDataCards = (data) => {
  return (
    <>
      <TaskIndicatorCard
        title="Total Actividades"
        value={
          data?.total_activities_created ? data?.total_activities_created : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="Total Actividades Delegadas"
        value={data?.total_objectives_to_me}
        margin={"0 0 10px 0"}
      />

      <TaskIndicatorCard
        title="Actividades Delegadas Ejecutadas (%)"
        value={
          data?.total_delegated_to_me_executed
            ? data?.total_delegated_to_me_executed +
              " (" +
              data?.delegated_executed_pct +
              " %)"
            : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        text={data?.delegated_compliance_message}
        color={data?.delegated_compliance_color}
      />
    </>
  );
};

export const indicatorsTaskDeletedCards = (data) => {
  return (
    <>
      <TaskIndicatorCard
        title="Total Objetivos"
        value={
          data?.total_objectives_created ? data?.total_objectives_created : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        title="Total Objetivos Eliminados"
        value={
          data?.total_objectives_deleted
            ? data?.total_objectives_deleted + " (" + data?.deleted_pct + " %)"
            : "-"
        }
        margin={"0 0 10px 0"}
      />
      <TaskIndicatorCard
        text={data?.deletion_message}
        color={data?.deletion_color}
      />
    </>
  );
};
